<template>
    <MainPage :pageTitle="title" bgClass="bg-a-gray-efefef">
        <PolicyList></PolicyList>
    </MainPage>
</template>

<script>
import MainPage from '@/components/Layout/Page/MainPage.vue'
import PolicyList from '../component/PolicyList.vue'
import { useTracking } from "@/feature/TrackingFeature"
import CacheHelper from "@/helper/CacheHelper.js"

export default {
    name: 'PolicyListing',
    components: {
        MainPage,
        PolicyList
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    data: function() {
        return {
            title: 'ความคุ้มครอง'
        }
    },
    created: function() {
        this.tracking.screenName('policy_list')
        this.tracking.event("policy_list_page", "view_policy_list", "", "");
        this.cache = new CacheHelper('local')
        this.cache.removeCache('policyId')
    },
}
</script>


